import React from "react";
import PropTypes from "prop-types";

export default class FieldExpenseCategory_PopoverMenuMore extends React.Component<any> {

    static propTypes = {
        parent: PropTypes.object,
        field: PropTypes.object
    }

    render() {
        return (
            <div className="help">
                <div className="ui5-link-small" onClick={()=>{
                    this.props.parent.hidePopover();
                    gd.modules.expenses.goToSettings()
                }}>
                    Edit expense types
                </div>
            </div>
        );
    }
}